import { MigrationPreview } from "@swivl-mono/api-helper";

import { MigrationItemRow } from "./MigrationItemRow";

interface MigrationGroupProps {
  group: MigrationPreview["groups"][number];
  selectedSpecIds: Set<string>;
  expandedSpecIds: Set<string>;
  onToggleSelected: (specId: string) => void;
  onToggleExpanded: (specId: string) => void;
}

export function MigrationGroup({
  group,
  selectedSpecIds,
  expandedSpecIds,
  onToggleSelected,
  onToggleExpanded
}: MigrationGroupProps): React.ReactElement {
  const count = group.items.length;
  // Entity-targeted specs (brand colors) are not LocationVars — don't call them "variables".
  const noun = group.items.every((item) => item.brandColorsTarget) ? (count === 1 ? "target" : "targets") : count === 1 ? "variable" : "variables";
  return (
    <section className="mb-6 rounded border border-grey-200 bg-white">
      <header className="flex items-center justify-between border-b border-grey-100 px-4 py-3">
        <h2 className="body-sm-alt text-grey-700">
          {group.groupLabel}{" "}
          <span className="body-xs ml-2 font-normal text-grey-400">
            ({count} {noun})
          </span>
        </h2>
      </header>
      <div className="divide-y divide-grey-100">
        {group.items.map((item) => (
          <MigrationItemRow
            key={item.specId}
            item={item}
            selected={selectedSpecIds.has(item.specId)}
            expanded={expandedSpecIds.has(item.specId)}
            onToggleSelected={() => onToggleSelected(item.specId)}
            onToggleExpanded={() => onToggleExpanded(item.specId)}
          />
        ))}
      </div>
    </section>
  );
}
